import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, EMPTY, finalize, take } from 'rxjs';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false,
})
export class ResetPasswordComponent implements OnInit {
    form: FormGroup;
    resetInProgress = false;
    message: string | undefined = undefined;
    isSuccess = false;
    email: string | null = null;

    constructor(
        private readonly fb: FormBuilder,
        private readonly authService: AuthService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
    ) {
        this.form = this.fb.group({
            password: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', [Validators.required]],
        }, { validators: this.passwordMatchValidator });
    }

    ngOnInit() {
        // Get email from query params if available
        this.email = this.route.snapshot.queryParams['email'];
    }

    passwordMatchValidator(control: AbstractControl): { [key: string]: boolean } | null {
        const password = control.get('password');
        const confirmPassword = control.get('confirmPassword');
        
        if (password && confirmPassword && password.value !== confirmPassword.value) {
            return { 'passwordMismatch': true };
        }
        return null;
    }

    resetPassword() {
        if (this.form.valid) {
            this.resetInProgress = true;
            this.message = undefined;
            this.isSuccess = false;
            
            const newPassword = this.form.get('password')?.value;
            
            this.authService
                .updatePassword(newPassword)
                .pipe(
                    take(1),
                    finalize(() => {
                        this.resetInProgress = false;
                    }),
                    catchError((err) => {
                        this.message = 'حدث خطأ أثناء إعادة تعيين كلمة المرور';
                        return EMPTY;
                    }),
                )
                .subscribe((result) => {
                    if (result.error) {
                        this.message = 'حدث خطأ أثناء إعادة تعيين كلمة المرور';
                    } else {
                        this.isSuccess = true;
                        this.message = 'تم إعادة تعيين كلمة المرور بنجاح';
                        // Redirect to login after 3 seconds
                        setTimeout(() => {
                            this.router.navigate(['/auth/login']);
                        }, 3000);
                    }
                });
        }
    }

    get passwordMismatch() {
        return this.form.hasError('passwordMismatch') && this.form.get('confirmPassword')?.touched;
    }
}
